import React, { useState, useEffect } from "react";
import { useCookies } from "react-cookie";

const Home = ({ setShowLoading }) => {
    const [cookies, setCookie, removeCookie] = useCookies(["user", "token"]);

    useEffect(() => {
        setShowLoading(false);
    }, []);
    return <div>Home</div>;
};
export default Home;
